// extracted by mini-css-extract-plugin
export default {"root":"CustomValueTab_root__13zGd","wrapper":"CustomValueTab_wrapper__1AVTK","inputTab":"CustomValueTab_inputTab__s27fw","labelTab":"CustomValueTab_labelTab__Slq2B"};